import { IResponse } from "models";

export enum ActionType {
  GET_TEMPERATURE_AMOUNTS_CHART = "action/GET_TEMPERATURE_AMOUNTS_CHART",
  GET_TEMPERATURE_AMOUNTS_CHART_SUCCESS = "action/GET_TEMPERATURE_AMOUNTS_CHART_SUCCESS",
  GET_TEMPERATURE_AMOUNTS_CHART_ERROR = "action/GET_TEMPERATURE_AMOUNTS_CHART_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface TemperatureAmountsPayload {
  aggregate_date_to: string;
}

export interface TemperatureAmountsResponse extends IResponse {
  amounts: any;
}
